import NavigationPanel from './NavigationPanel';

export default NavigationPanel;
